import { Button, Popover } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface button {
  onClick: any;
  disabled?: boolean
}

const EditButton = ({ onClick, disabled }: button) => {
  const [t] = useTranslation("common");

  const lockColor = disabled ? "gray" : "#212121"; // Red for locked, Green for unlocked
  const content = <div>{t("edit")}</div>;

  const handleEditClick = () => {
    onClick();
  };

  return (
    <>
      <Popover content={content} mouseEnterDelay={0} mouseLeaveDelay={0}>
        <Button
          disabled={disabled}
          className="Button"
          type="text"
          icon={<EditOutlined style={{ color: lockColor, fontSize: "14px" }} />}
          onClick={handleEditClick}
          size={"small"}
        />
      </Popover>
    </>
  );
};

export default EditButton;
